var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:( _obj = {}, _obj[_vm.css.readMore] = true, _obj[_vm.css[_vm.size]] = true, _obj ),attrs:{"to":_vm.to,"type":_vm.tag === 'button' ? 'button' : null}},[_vm._t("default",function(){return [_vm._v("Читать")]}),_vm._v(" "),(_vm.withChevron)?_c('SvgIcon',{class:_vm.css.chevron,attrs:{"name":"chevron"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }